<template>

  <Container type="card-full" v-loading="loading">
    <div slot="header">
    </div>
    <div class="split-line"></div>
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">类型</div>
            <div class="view-value">{{pjnotice.pjnoticetypedesc}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">主题</div>
            <div class="view-content">{{pjnotice.pjnoticetitle}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">同时发布到</div>
            <div>
              <el-checkbox-group v-model="checkList" style="color:#66ccff;">
                  <el-checkbox v-for="i in picrList" :key="i.picid" :label="i.piccode">
                    {{i.picname}}
                  </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">公告附件</div>
            <div v-if="appendList && appendList.length" class="view-filelist">
              <div v-for="(item,index) in appendList" :key="index" class="view-fileitem">
                <div class="view-filename" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">采购文件</div>
            <div v-if="projectAppendList && projectAppendList.length" class="view-filelist">
              <div v-for="(item,index) in projectAppendList" :key="index" class="view-fileitem">
                <div class="view-filename" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
            <span style="color: red; margin-left: 12px;">{{ +project.projectpfvisible === 1 ? '公告中可见' : '公告中不可见' }}</span>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">内容</div>
            <div class="view-text">
              <div v-html="pjnotice.pjnoticedesc" style="margin-top:-12px"></div>
            </div>
          </div>
        </div>
        
        <template v-if="project.projectjjbgstatus && +pjnotice.pjnoticetype === 3">
          <div class="split-line"></div>
          <div style="margin-left: 25px;">
            <div class="view-row">
          <div class="view-field">
            <div class="view-label">失败报告附件</div>
            <div v-if="bgAppendList && bgAppendList.length" class="view-filelist">
              <div v-for="(item,index) in bgAppendList" :key="index" class="view-fileitem">
                <div class="view-filename" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
          </div>
        </div>
          <div class="view-row">
          <div class="view-field">
            <div class="view-label">失败报告内容</div>
            <div class="view-text">
              <div v-html="pjnotice.projectjjcontent" style="margin-top:-12px"></div>
            </div>
          </div>
          </div>
        </div>
        </template>
      </div>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import E from 'wangeditor'
  import config from '../../assets/config'
  import uploadBtn from '../common/uploadBtn'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'

  export default {
    name: "pjnoticeForm",
    mixins: [common],
    data () {
      return {
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() <= Date.now() - 86400000
          }
        },
        projectAppendList:[],
        pjnotice: {},
        project: this.$route.params.form,
        pjnoticetypeList: [],
        appendList: [],
        type: Number(this.$route.params.type),
        btnLoading: false,
        editorContent: '',
        editor: '',
        picrList:[],
        checkList:[],
        bgAppendList: [],
        loading:false
      }
    },
    created () {
    },
    async activated () {
      await this.init()
      await this.getAppendList()
      if (this.$route.params.pjnoticeid) {
        await this.getModel()
        await this.getProjectModel()
      }
      await this.getPjnoticetypeList()
      
      await this.getPicrList()
    },
    mounted () {
      // this.initEditor()
    },
    // watch: {
    //   $route (to, from) {
    //     to.name === 'pjnoticeForm'
    //   }
    // },
    filters: {},
    components: {uploadBtn},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      appendfromtype () {
        let appendfromtype = ''
        if (this.pjnotice.pjnoticetype == '1') {
          appendfromtype = '12'
        } else if (this.pjnotice.pjnoticetype == '2') {
          appendfromtype = '13'
        } else if (this.pjnotice.pjnoticetype == '3') {
          appendfromtype = '14'
        } else if (this.pjnotice.pjnoticetype == '4') {
          appendfromtype = '15'
        }
        return appendfromtype
      }
    },
    deactivated () {
      this.$destroy()
    },
    methods: {
      async getAppendList() {
        let res = await request({
          method: "get",
          url: "/ywgl/append/getAppendListByFromId",
          params: {
            appendfromid: this.$route.params.projectid,
            appendfromtype: 20,
          },
        });
        this.bgAppendList = res;
    },
      async getModel () {
        this.loading = true
        this.pjnotice = await request({
          url: '/xmgl/pjnotice/getPJNoticeListById',
          method: "get",
          params: {pjnoticeid: this.$route.params.pjnoticeid,cosid:this.$store.getters.loginUser.cosid}
        })
        this.appendList = this.pjnotice.appendList
        this.editorContent = this.pjnotice.pjnoticedesc
        this.checkList = this.pjnotice.checkList
        this.loading = false
      },
      async getPicrList(){
        //获取接口
        let data = await request({
            url: '/xmgl/pjnotice/getPicrList',
            method: "get",
            params:{cosid:this.$store.getters.loginUser.cosid}
          })
          this.picrList = data
      },
      async getProjectModel () {
        this.project = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.params.projectid}
        })
        this.projectAppendList = this.project.appendList_zb
      },
      pjnoticetypeChange (val) {
        let name = ''
        let model = this.pjnoticetypeList.find(v => v.value == val)
        if (model) {
          name = model.label
        }
        this.pjnotice.pjnoticetitle ='关于'+ this.project.projectname +'(项目编号：'+ this.project.projectcode + ')'+'的' + name
      },
      async getPjnoticetypeList () {
        this.pjnoticetypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'pjnoticetype'}
        })
      },
      async init () {
        this.btnLoading = false
        // this.pjnoticetitle = '关于'+ this.project.projectname +'(项目编号：'+ this.project.projectcode + ')'+'的' + this.wmenu.wmenuname
      },
      delappend (file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        }).catch(() => {
        })
      },
      async setfile (path, filename) {
        let append = {
          appendid: 0,
          appendfromid: 0,
          appendfromtype: this.appendfromtype,
          appendtype: '100',
          appendseq: this.appendList.length + 1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr, '')
        }
        this.appendList.push(append)
      },
      async addOrEdit () {
        this.submitForm('ruleForm').then(async() => {
          if (this.$route.params.form) {
            this.pjnotice.pjnoticeprojectid = this.project.projectid
          }
          this.pjnotice.pjnoticedesc = this.editorContent
          this.pjnotice.appends = this.appendList
          this.pjnotice.pjnoticestatus = 0
          let data = await request({
            url: '/xmgl/pjnotice/addOrEdit',
            method: "post",
            data: this.pjnotice
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        console.log('this.$route.name', this.$route.name)

        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pjnoticeIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .view-container .view-box .view-row .view-field .view-label {
    width: 100px;
  }
  .view-container .view-box .view-row .view-field .view-content span{
    color:#66ccff;
  }
</style>

